import { ContactDealerAddressDetailsProps } from '../../../types';
import styles from '../../../Product.module.scss';
import cx from 'classnames';

export const ContactDealerAddressDetails = ({
  label,
  children,
  textClassName
}: ContactDealerAddressDetailsProps) => {
  return (
    <div className="mb-3">
      <p className={textClassName}>
        <span className={cx('fw-bold', styles['product-text'])}>{label}</span>
        {children}
      </p>
    </div>
  );
};
